import { useQuery } from "@tanstack/react-query";
import React from "react";
import SkillCard from "./SkillCard";

const Skills = () => {
  const { data: skillsImages = [], isLoading } = useQuery({
    queryKey: ["skillsImages"],
    queryFn: async () => {
      const res = await fetch("skills.json");
      const data = await res.json();
      return data;
    },
  });
  return (
    <div className="container m-auto text-center" id="skills">
      {" "}
      <h1 className=" font-bold text-white mb-16" style={{ fontSize: "6rem" }}>
        MY SKILLS
      </h1>
      <div className="grid grid-cols-1 lg:grid-cols-6 gap-6">
        {skillsImages.map((img) => (
          <SkillCard key={img.id} img={img}></SkillCard>
        ))}
      </div>
      <hr className="mt-16" />
    </div>
  );
};

export default Skills;
